export default {
  orders: [],
  orderCount: 0,
  customerCount: 0,
  subscriberCount: 0,
  storeBalance: {},
  storeReport: {},
  reportsMessages: { nextPageToken: "", data: [] },
  reportsClicks: { nextPageToken: "", data: [] },
  reportsConversion: { nextPageToken: "", data: [] },
  reportsStream: { nextPageToken: "", data: [] },
  campaignsMessages: { nextPageToken: "", data: [] },
  campaignsClicks: { nextPageToken: "", data: [] },
  campaignsConversions: { nextPageToken: "", data: [] },
  existingDiscounts: [],
  shippingCountries: []
};
